module.exports = __webpack_public_path__ + "/img/Oscillator-JLead-Labeled-TTkO5f.svg";